export const routeConstants = {
	inventory: (stateId = ':stateId', denomination = ':denomination') =>
		`/inventory/${stateId}/${denomination}`,
	bulkInventory: (stateId = ':stateId', denomination = ':denomination') =>
		`/bulk-inventory/${stateId}/${denomination}`,
	APPROVALS: (page = ':page', id = ':id') => `/approvals/${page}/${id}`,
	EDIT: '/edit',
	TEMPLATE: '/template',
	PROFILE: '/profile',
	PROFILE_EDIT: '/profile-edit',
	PERSONAL_INFO: '/personalInfo',
	DASHBOARD: '/dashboard',
	WALLET: '/wallet',
	WALLET_HISTORY: '/walletHistory',
	UAM: '/uam',
	SIGNATURE: '/individual/signature',
	SETTINGS: '/setting',
	RESET_PASSWORD_PROFILE: '/reset-password-profile',
	STATISTICS: '/statistics',
	BULK_ESIGN: '/bulk-esign',
	NEW_ESIGN: '/new-esign',
	LANDING_PAGE: '/',
	RESET_PASSWORD: '/reset-password',
	FORGET_PASSWORD: '/forget-password',
	LOGIN: '/login',
	SIGN_UP: '/signup',
	ACTION_REQUIRED: '/individual/action-required',
	WAITING_FOR_OTHERS: '/individual/Waiting-for-others',
	SIGNED: '/individual/signed',
	UNSUCCESSFUL_WORKFLOWS: '/individual/unsuccessful-workflows'
};
